import React, { useEffect, useState } from 'react';
import './styles';
import UIMultiImageSelect from '../../../../../components/UI/UIMultiImageSelect';
import { TYPES } from '../../../../../components/UI/UIMultiImageSelect/config';
import { useLazyQuery } from '@apollo/react-hooks';
import Queries from '../../../../../utils/API/Queries';
import * as strings from './strings';
import { FILE_STATUS_LIVE, FILE_TYPE_FLOOR_PLAN } from '../../../../../utils/Config/Constants';
import { GET_LISTING_AGGREGATED_FLOOR_PLANS } from './queries';
import PLUpload from '../../../../../components/PL/PLUpload';
import UISegmentedControl from '../../../../../components/UI/UISegmentedControl';
import { filterFloorplansByTab } from '../../../../../components/PL/PLSortable/helpers';
import { DIMENSIONS, NO_DIMENSIONS } from '../../../../../components/PL/PLSortable';
import UIDropdownSelect from '../../../../../components/UI/UIDropdownSelect';

export default function ListingFloorPlans({ listingId }: ListingFloorPlansProps) {
	const [aggregatedFloorPlans, setAggregatedFloorPlans] = useState<FileType[]>();
	const [listing, setListing] = useState<ListingType>();
	const [selectedFloorPlanTab, setSelectedFloorPlanTab] = useState<PLSegment>();

	const [getListing, { data: listingData }] = useLazyQuery(GET_LISTING_AGGREGATED_FLOOR_PLANS, { variables: { id: listingId } });
	const [getAggregatedFloorPlans, { data: aggregatedFloorPlansData }] = useLazyQuery(Queries.GET_FILES_WITH_QUERY);

	const getTabs = () => {
		return [DIMENSIONS, NO_DIMENSIONS];
	};

	useEffect(() => {
		(async () => {
			await getListing();
		})();
	}, []);

	useEffect(() => {
		if (listingData) {
			const fetchedListing: ListingType = listingData['listing'];
			setListing(fetchedListing);
			getAggregatedFloorPlans({
				variables: { order: [['index']], limit: 1000, query: { listingId: fetchedListing.id, status: FILE_STATUS_LIVE, type: FILE_TYPE_FLOOR_PLAN } }
			});
		}
	}, [listingData]);

	useEffect(() => {
		if (aggregatedFloorPlansData) {
			const fetchedFloorPlans: FileType[] = aggregatedFloorPlansData['files'];
			setAggregatedFloorPlans(fetchedFloorPlans);
			setSelectedFloorPlanTab(getTabs()[0]);
		}
	}, [aggregatedFloorPlansData]);

	if (!listing || !aggregatedFloorPlans) return null;

	const renderSegmentedControl = () => {
		const segments = getTabs();

		return (
			segments.length > 0 &&
			selectedFloorPlanTab && (
				<UISegmentedControl
					className='listingFloorplans--tabs'
					segments={segments}
					selectedSegment={selectedFloorPlanTab}
					updateSelectedSegment={setSelectedFloorPlanTab}
				/>
			)
		);
	};

	const renderContent = () => {
		const filteredFiles = filterFloorplansByTab(aggregatedFloorPlans, selectedFloorPlanTab);
		return (
			<UIMultiImageSelect
				emptySetTitle={strings.emptySetTitle}
				emptySetDescription={strings.emptySetDescription}
				type={TYPES.floorPlan}
				updateData={getListing}
				files={filteredFiles}
				listing={listing}
				disableSort={false}
				rightItem={renderUpload()}
			/>
		);
	};

	const renderUpload = () => {
		return (
			<PLUpload
				multiple={true}
				localeTranslations={strings.floorPlansLocaleTranslations}
				fileType={FILE_TYPE_FLOOR_PLAN}
				onFileUploadComplete={getListing}
				postData={{ listingId: listing.id }}
				uploadStatus={FILE_STATUS_LIVE}
				tagData={{ withDimension: selectedFloorPlanTab?.value === DIMENSIONS.value }}
			/>
		);
	};

	return (
		<div className='listingVideos'>
			{renderSegmentedControl()}
			{renderContent()}
		</div>
	);
}
